/* =====================================================================
   TSV — Save to shelf: click handling only.

   The button and the discount badge are rendered server-side by
   snippets/tsv-card-shelf.liquid, which is included in every product card
   file. This script does NOT create or inject any markup. Its only jobs:

     1. Handle the click (save / unsave) against the worker
     2. Reflect saved state on load

   Delegated listener, so it also covers cards that arrive via section
   rendering, search dropdowns or the brand rail that clones nodes.
   ===================================================================== */
(function () {
  'use strict';

  // Prefer the standalone config (always present, set in theme.liquid) and
  // fall back to the concierge's, which only exists when the chat renders.
  var SHELF = window.__TSV_SHELF || {};
  var CFG = window.__TSV_CONFIG || {};
  var WORKER = String(SHELF.endpoint || CFG.endpoint || '')
    .replace(/\/chat\/?$/, '')
    .replace(/\/+$/, '');
  if (!WORKER) return;

  var SESSION_KEY = 'tsv_session_id';
  var SHELF_KEY = 'tsv_shelf_ids';

  function customerId() {
    if (SHELF.customerId) return String(SHELF.customerId).replace(/\D/g, '');
    var c = CFG.customer;
    return (c && c.id) ? String(c.id).replace(/\D/g, '') : '';
  }

  function sessionId() {
    try {
      var s = window.localStorage.getItem(SESSION_KEY);
      if (!s) {
        s = 'tsv_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        window.localStorage.setItem(SESSION_KEY, s);
      }
      return s;
    } catch (_) { return ''; }
  }

  function saved() {
    try { return JSON.parse(window.localStorage.getItem(SHELF_KEY) || '[]'); }
    catch (_) { return []; }
  }
  function setSaved(list) {
    try { window.localStorage.setItem(SHELF_KEY, JSON.stringify(list)); } catch (_) {}
  }

  /* ---- reflect saved state on the server-rendered buttons ---------- */
  function paint(ids) {
    var btns = document.querySelectorAll('[data-tsv-shelf-btn]');
    for (var i = 0; i < btns.length; i++) {
      var id = btns[i].getAttribute('data-product-id');
      var on = ids.indexOf(String(id)) !== -1;
      btns[i].classList.toggle('is-saved', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function refresh() {
    paint(saved().map(String));
    var cid = customerId();
    var body = cid ? { customer_id: cid } : { session_id: sessionId() };
    fetch(WORKER + '/wardrobe/get', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.items) return;
        var ids = j.items.map(function (it) { return String(it.product_id); });
        setSaved(ids);
        paint(ids);
        tsvHydrateVerifiedRatings(j.items);
      })
      .catch(function () {});
  }

  /* Reflect the worker's saved ratings onto the Buy Again cards on load. The stars
     render from the Shopify metafield, which can lag behind the worker, so we read
     the same source we save to and reveal + fill the stars (and feed the picker). */
  function tsvHydrateVerifiedRatings(items) {
    if (!items || !items.length) return;
    var map = {};
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it && it.product_id != null) map[String(it.product_id)] = it;
    }
    var metas = document.querySelectorAll('.tsv-account-page [data-tsv-shelf][data-lock-rating]');
    for (var m = 0; m < metas.length; m++) {
      var meta = metas[m];
      var rec = map[String(meta.getAttribute('data-product-id') || '')];
      if (!rec) continue;
      var rating = parseInt(rec.rating, 10) || 0;
      if (rating <= 0) continue;
      var note = rec.notes || rec.note || '';
      meta.setAttribute('data-rating', String(rating));
      if (note) meta.setAttribute('data-note', note);
      var stars = meta.querySelectorAll('.tsv-shelf-star');
      for (var s = 0; s < stars.length; s++) { var on = (s + 1) <= rating; stars[s].classList.toggle('is-on', on); stars[s].textContent = on ? '★' : '☆'; }
      var wrap = meta.querySelector('.tsv-shelf-stars');
      if (wrap) { wrap.classList.remove('tsv-shelf-stars--empty'); wrap.classList.add('is-rated'); }
    }
  }

  /* ---- click ------------------------------------------------------ */
  /* Small inline "Remove?" confirm, shown when un-saving from the Fragrance Shelf. */
  function tsvShelfConfirm(anchorBtn, onYes){
    var old = document.querySelector('.tsv-shelf-confirm'); if (old) old.remove();
    var card = anchorBtn.closest('.tsv-product-card') || anchorBtn.parentNode;
    var pop = document.createElement('div');
    pop.className = 'tsv-shelf-confirm';
    pop.innerHTML =
      '<div class="tsv-shelf-confirm__msg">Remove?</div>' +
      '<div class="tsv-shelf-confirm__row">' +
        '<button type="button" class="tsv-shelf-confirm__no">No</button>' +
        '<button type="button" class="tsv-shelf-confirm__yes">Yes</button>' +
      '</div>';
    if (card && card.style) {
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.appendChild(pop);
    } else { document.body.appendChild(pop); }
    function close(){ try{ pop.remove(); }catch(e){} document.removeEventListener('click', outside, true); }
    function outside(e){ if (!pop.contains(e.target) && e.target !== anchorBtn) close(); }
    setTimeout(function(){ document.addEventListener('click', outside, true); }, 0);
    pop.querySelector('.tsv-shelf-confirm__no').addEventListener('click', function(e){ e.stopPropagation(); close(); });
    pop.querySelector('.tsv-shelf-confirm__yes').addEventListener('click', function(e){ e.stopPropagation(); close(); onYes(); });
  }

  /* Toggle save/unsave. cardToRemove (optional) fades + removes the card instantly. */
  function tsvPerformToggle(btn, pid, adding, cardToRemove){
    btn.classList.toggle('is-saved', adding);
    btn.setAttribute('aria-pressed', adding ? 'true' : 'false');
    btn.classList.add('is-pulse');
    setTimeout(function () { btn.classList.remove('is-pulse'); }, 420);

    var list = saved().map(String);
    if (adding) { if (list.indexOf(pid) === -1) list.push(pid); }
    else { list = list.filter(function (x) { return x !== pid; }); }
    setSaved(list);
    paint(list);

    if (cardToRemove) {
      cardToRemove.style.transition = 'opacity .2s ease';
      cardToRemove.style.opacity = '0';
      setTimeout(function(){ try{ cardToRemove.remove(); }catch(e){} }, 210);
    }

    var payload = {
      product_id: pid,
      status: 'wishlist',
      session_id: sessionId(),
      product_title: btn.getAttribute('data-title') || '',
      product_vendor: btn.getAttribute('data-vendor') || '',
      product_image: btn.getAttribute('data-image') || '',
      product_url: btn.getAttribute('data-url') || ''
    };
    var cid = customerId();
    if (cid) payload.customer_id = cid;

    fetch(WORKER + (adding ? '/wardrobe/add' : '/wardrobe/remove'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) {
        if (!j || j.ok !== true) throw new Error('failed');
        /* Hybrid save toast: only on a CONFIRMED save (not unsave, not the optimistic
           flip). First save of the session shows the full toast with a View link to the
           Member's Vault; after that the bookmark fill is feedback enough. */
        if (adding && !window.__tsvSaveToastShown && typeof window.tsvToast === 'function') {
          window.__tsvSaveToastShown = true;
          try {
            window.tsvToast({
              title: 'Saved to your Member’s Vault',
              sub: btn.getAttribute('data-title') || '',
              action: 'VIEW',
              actionHref: '/account#fragrance-shelf',
              accent: '#16265c'
            });
          } catch (e) {}
        }
      })
      .catch(function () {
        var back = saved().map(String);
        if (adding) back = back.filter(function (x) { return x !== pid; });
        else if (back.indexOf(pid) === -1) back.push(pid);
        setSaved(back);
        paint(back);
      });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-tsv-shelf-btn]') : null;
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();

    var pid = String(btn.getAttribute('data-product-id') || '');
    if (!pid) return;

    var adding = !btn.classList.contains('is-saved');

    // On the Fragrance Shelf (a saved-item card, identified by its remove control), un-saving
    // asks to confirm and then removes the card instantly. Everywhere else it's a silent toggle.
    var card = btn.closest('.tsv-product-card');
    var onShelf = card && card.querySelector('[data-tsv-shelf-remove]');
    if (!adding && onShelf) {
      tsvShelfConfirm(btn, function(){ tsvPerformToggle(btn, pid, false, card); });
      return;
    }
    tsvPerformToggle(btn, pid, adding, null);
  }, true);

  /* ---- shelf status + rating (tappable) --------------------------- */
  /* Both save via /wardrobe/add, which upserts status + rating + note together. We read
     all three from the shared .tsv-shelf-meta so changing one never wipes the others,
     then update the row's data so the next tap sends the fresh values. */
  function tsvShelfSave(meta) {
    if (!meta) return;
    var pid = String(meta.getAttribute('data-product-id') || '');
    if (!pid) return;
    meta.classList.add('is-saving');
    var payload = {
      product_id: pid,
      status: meta.getAttribute('data-status') || 'wishlist',
      rating: parseInt(meta.getAttribute('data-rating'), 10) || 0,
      notes: meta.getAttribute('data-note') || '',
      session_id: sessionId()
    };
    var cid = customerId();
    if (cid) payload.customer_id = cid;
    fetch(WORKER + '/wardrobe/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) { if (!j || j.ok !== true) throw new Error('failed'); })
      .catch(function () {})
      .then(function () { meta.classList.remove('is-saving'); });
  }

  /* ---- verified review modal (Buy Again rows) --------------------- */
  /* Opens on star tap for data-lock-rating rows. Captures a rating + a written
     review, then writes both back onto the shared .tsv-shelf-meta and saves via
     the same /wardrobe/add upsert (which already stores a notes field). */
  /* Mount modals in a body-level portal so position:fixed resolves against the
     viewport, not the account section (which the theme's scroll-reveal animation
     gives a transform, breaking centering). The portal keeps the .tsv-account-page
     class for CSS variables + scoped styling; .tsv-acct-portal resets the page chrome. */
  function tsvModalHost() {
    var h = document.getElementById('tsv-acct-modal-portal');
    if (!h) {
      h = document.createElement('div');
      h.id = 'tsv-acct-modal-portal';
      h.className = 'tsv-account-page tsv-acct-portal';
      document.body.appendChild(h);
    }
    return h;
  }

  var _revModal = null;
  function tsvBuildReviewModal() {
    if (_revModal) return _revModal;
    var ov = document.createElement('div');
    ov.className = 'tsv-revmodal';
    ov.setAttribute('hidden', '');
    ov.innerHTML =
      '<div class="tsv-revmodal__backdrop" data-rev-close></div>' +
      '<div class="tsv-revmodal__box" role="dialog" aria-modal="true" aria-label="Leave a review">' +
        '<button type="button" class="tsv-revmodal__x" data-rev-close aria-label="Close">×</button>' +
        '<div class="tsv-revmodal__form" data-rev-form>' +
          '<div class="tsv-revmodal__eyebrow">Verified review</div>' +
          '<div class="tsv-revmodal__title" data-rev-title>Rate this fragrance</div>' +
          '<div class="tsv-revmodal__stars" data-rev-stars role="group" aria-label="Your rating">' +
            '<button type="button" class="tsv-revmodal__star" data-val="1" aria-label="1 star">☆</button>' +
            '<button type="button" class="tsv-revmodal__star" data-val="2" aria-label="2 stars">☆</button>' +
            '<button type="button" class="tsv-revmodal__star" data-val="3" aria-label="3 stars">☆</button>' +
            '<button type="button" class="tsv-revmodal__star" data-val="4" aria-label="4 stars">☆</button>' +
            '<button type="button" class="tsv-revmodal__star" data-val="5" aria-label="5 stars">☆</button>' +
          '</div>' +
          '<textarea class="tsv-revmodal__text" data-rev-note rows="4" maxlength="600" placeholder="What did you think? How does it wear, and when would you reach for it?"></textarea>' +
          '<div class="tsv-revmodal__actions">' +
            '<button type="button" class="tsv-revmodal__cancel" data-rev-close>Cancel</button>' +
            '<button type="button" class="tsv-revmodal__save" data-rev-save>Save review</button>' +
          '</div>' +
        '</div>' +
        '<div class="tsv-revmodal__done" data-rev-done hidden>' +
          '<div class="tsv-revmodal__donecheck" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20 6 9 17l-5-5"></path></svg>' +
          '</div>' +
          '<div class="tsv-revmodal__donetitle">Review saved</div>' +
          '<div class="tsv-revmodal__donesub">Thanks for helping other members choose their next scent.</div>' +
        '</div>' +
      '</div>';
    var host = tsvModalHost();
    host.appendChild(ov);
    _revModal = ov;

    function paintStars(v) {
      var sb = ov.querySelectorAll('.tsv-revmodal__star');
      for (var i = 0; i < sb.length; i++) { var on = (i + 1) <= v; sb[i].textContent = on ? '★' : '☆'; sb[i].classList.toggle('is-on', on); }
    }
    ov._paintStars = paintStars;

    ov.addEventListener('click', function (e) {
      var st = e.target.closest ? e.target.closest('.tsv-revmodal__star') : null;
      if (st) { ov._pickVal = parseInt(st.getAttribute('data-val'), 10) || 0; paintStars(ov._pickVal); return; }
      if (e.target.closest && e.target.closest('[data-rev-close]')) { tsvCloseReviewModal(); return; }
      if (e.target.closest && e.target.closest('[data-rev-save]')) { tsvSaveReviewModal(); return; }
    });
    return ov;
  }

  function tsvOpenReviewModal(meta, initialVal) {
    var ov = tsvBuildReviewModal();
    ov._meta = meta;
    var v = initialVal || parseInt(meta.getAttribute('data-rating'), 10) || 0;
    ov._pickVal = v;
    ov._paintStars(v);
    var ta = ov.querySelector('[data-rev-note]');
    if (ta) ta.value = meta.getAttribute('data-note') || '';
    // Reset to the form view in case a previous save left the confirmation showing.
    var _form = ov.querySelector('[data-rev-form]'); if (_form) _form.hidden = false;
    var _done = ov.querySelector('[data-rev-done]'); if (_done) _done.hidden = true;
    if (ov._doneTimer) { clearTimeout(ov._doneTimer); ov._doneTimer = null; }
    var card = meta.closest('.tsv-product-card');
    var nameEl = card && card.querySelector('.tsv-product-card__title');
    var name = nameEl ? nameEl.textContent.trim() : '';
    var titleEl = ov.querySelector('[data-rev-title]');
    if (titleEl) titleEl.textContent = name ? ('Review ' + name) : 'Rate this fragrance';
    ov.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { if (ta) ta.focus(); }, 40);
  }

  function tsvCloseReviewModal() {
    if (!_revModal) return;
    _revModal.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  function tsvSaveReviewModal() {
    var ov = _revModal;
    if (!ov || !ov._meta) return;
    var meta = ov._meta;
    var val = ov._pickVal || 0;
    if (!val) {
      var sw = ov.querySelector('.tsv-revmodal__stars');
      if (sw) { sw.classList.add('tsv-revmodal__stars--err'); setTimeout(function () { sw.classList.remove('tsv-revmodal__stars--err'); }, 500); }
      return;
    }
    var ta = ov.querySelector('[data-rev-note]');
    var note = ta ? ta.value.trim() : '';
    meta.setAttribute('data-rating', String(val));
    meta.setAttribute('data-note', note);
    var stars = meta.querySelectorAll('.tsv-shelf-star');
    for (var i = 0; i < stars.length; i++) { var on = (i + 1) <= val; stars[i].classList.toggle('is-on', on); stars[i].textContent = on ? '★' : '☆'; }
    var wrap = meta.querySelector('.tsv-shelf-stars');
    if (wrap) {
      wrap.classList.remove('tsv-shelf-stars--empty'); // reveal now that it is reviewed
      if (meta.hasAttribute('data-lock-rating')) wrap.classList.add('is-rated');
    }
    tsvShelfSave(meta);
    // Show the saved confirmation in place, then auto-close.
    var _form = ov.querySelector('[data-rev-form]'); if (_form) _form.hidden = true;
    var _done = ov.querySelector('[data-rev-done]'); if (_done) _done.hidden = false;
    ov._doneTimer = setTimeout(function () { tsvCloseReviewModal(); }, 1600);
  }

  /* ---- product picker (Write a review) --------------------------- */
  /* Lists the member's Buy Again products (their verified purchases) so they can
     choose which one to review; picking one opens the review modal for that card. */
  var _pickModal = null;
  function tsvBuildPicker() {
    if (_pickModal) return _pickModal;
    var ov = document.createElement('div');
    ov.className = 'tsv-revmodal tsv-revpick';
    ov.setAttribute('hidden', '');
    ov.innerHTML =
      '<div class="tsv-revmodal__backdrop" data-pick-close></div>' +
      '<div class="tsv-revmodal__box" role="dialog" aria-modal="true" aria-label="Choose a product to review">' +
        '<button type="button" class="tsv-revmodal__x" data-pick-close aria-label="Close">×</button>' +
        '<div class="tsv-revmodal__eyebrow">Verified review</div>' +
        '<div class="tsv-revmodal__title">Choose a product to review</div>' +
        '<div class="tsv-revpick__list" data-pick-list></div>' +
      '</div>';
    var host = tsvModalHost();
    host.appendChild(ov);
    _pickModal = ov;
    ov.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pick-close]')) { tsvClosePicker(); return; }
      var item = e.target.closest ? e.target.closest('.tsv-revpick__item') : null;
      if (item && item._meta) { tsvClosePicker(); tsvOpenReviewModal(item._meta); }
    });
    return ov;
  }

  function tsvOpenReviewPicker() {
    var ov = tsvBuildPicker();
    var list = ov.querySelector('[data-pick-list]');
    list.innerHTML = '';
    var metas = document.querySelectorAll('.tsv-account-page [data-tsv-shelf][data-lock-rating]');
    var added = 0;
    for (var i = 0; i < metas.length; i++) {
      var meta = metas[i];
      if ((parseInt(meta.getAttribute('data-rating'), 10) || 0) > 0) continue; // already reviewed, hide
      var card = meta.closest('.tsv-product-card') || meta.closest('.tsv-qa-card');
      var nameEl = card && card.querySelector('.tsv-product-card__title');
      var name = nameEl ? nameEl.textContent.trim() : 'This fragrance';
      var imgEl = card && card.querySelector('.tsv-qa-media__link img, .tsv-product-card__image img');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tsv-revpick__item';
      btn._meta = meta;
      btn.innerHTML =
        (imgEl ? '<img class="tsv-revpick__img" src="' + imgEl.getAttribute('src') + '" alt="" loading="lazy">' : '<span class="tsv-revpick__img"></span>') +
        '<span class="tsv-revpick__meta"><span class="tsv-revpick__name">' + name + '</span><span class="tsv-revpick__state">Not reviewed yet</span></span>';
      list.appendChild(btn);
      added++;
    }
    if (!added) {
      list.innerHTML = metas.length
        ? '<div class="tsv-revmodal__done">' +
            '<div class="tsv-revmodal__donecheck" aria-hidden="true"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20 6 9 17l-5-5"></path></svg></div>' +
            '<div class="tsv-revmodal__donetitle">All reviewed</div>' +
            '<div class="tsv-revmodal__donesub">You have reviewed every fragrance you own. Thank you for sharing your verdict.</div>' +
          '</div>'
        : '<p class="tsv-revpick__empty">You have no purchases to review yet.</p>';
    }
    ov.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }

  function tsvClosePicker() {
    if (!_pickModal) return;
    _pickModal.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest ? e.target.closest('[data-tsv-review-open]') : null;
    if (open) { e.preventDefault(); tsvOpenReviewPicker(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (_revModal && !_revModal.hasAttribute('hidden')) tsvCloseReviewModal();
    else if (_pickModal && !_pickModal.hasAttribute('hidden')) tsvClosePicker();
  });

  document.addEventListener('click', function (ev) {
    var star = ev.target.closest ? ev.target.closest('.tsv-shelf-star') : null;
    if (star) {
      ev.preventDefault(); ev.stopPropagation();
      var meta = star.closest('[data-tsv-shelf]');
      if (!meta || meta.classList.contains('is-saving')) return;
      var val = parseInt(star.getAttribute('data-val'), 10) || 0;
      if (!val) return;
      /* Verified review rows (Buy Again = data-lock-rating) open a modal so the
         member can pick a rating AND write a proper review before it saves. The
         Fragrance Shelf has no data-lock-rating, so it keeps the instant quick-rate. */
      if (meta.hasAttribute('data-lock-rating')) {
        tsvOpenReviewModal(meta, val);
        return;
      }
      var stars = meta.querySelectorAll('.tsv-shelf-star');
      for (var i = 0; i < stars.length; i++) { var on = (i + 1) <= val; stars[i].classList.toggle('is-on', on); stars[i].textContent = on ? '★' : '☆'; }
      meta.setAttribute('data-rating', String(val));
      tsvShelfSave(meta);
      return;
    }
    var chip = ev.target.closest ? ev.target.closest('.tsv-shelf-statuschip') : null;
    if (chip) {
      ev.preventDefault(); ev.stopPropagation();
      var meta2 = chip.closest('[data-tsv-shelf]');
      if (!meta2 || meta2.classList.contains('is-saving')) return;
      var st = chip.getAttribute('data-status') || '';
      if (!st) return;
      var chips = meta2.querySelectorAll('.tsv-shelf-statuschip');
      for (var k = 0; k < chips.length; k++) { chips[k].classList.toggle('is-on', chips[k] === chip); }
      meta2.setAttribute('data-status', st);
      tsvShelfSave(meta2);
      return;
    }
  }, true);

  /* ---- remove from shelf (account page) --------------------------- */
  document.addEventListener('click', function (ev) {
    var rm = ev.target.closest ? ev.target.closest('[data-tsv-shelf-remove]') : null;
    if (!rm) return;
    ev.preventDefault();
    ev.stopPropagation();

    var pid = String(rm.getAttribute('data-product-id') || '');
    if (!pid || rm.disabled) return;

    var card = rm.closest('.tsv-product-card') || rm.parentNode;
    rm.disabled = true;
    if (card) { card.style.transition = 'opacity .2s ease'; card.style.opacity = '.4'; }

    var payload = { product_id: pid, session_id: sessionId() };
    var cid = customerId();
    if (cid) payload.customer_id = cid;

    fetch(WORKER + '/wardrobe/remove', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) {
        if (!j || j.ok !== true) throw new Error('failed');
        // Drop it from the row and keep the local cache in step.
        setSaved(saved().map(String).filter(function (x) { return x !== pid; }));
        if (card && card.parentNode) card.parentNode.removeChild(card);
        paint(saved().map(String));
      })
      .catch(function () {
        rm.disabled = false;
        if (card) card.style.opacity = '1';
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // Repaint after Shopify section rendering swaps card markup in.
  document.addEventListener('shopify:section:load', function () { paint(saved().map(String)); });
})();